import { doDefaultFetch } from '@nhl/fetch-helpers';

const publicUrl = (args) => args.isPublic ? '/public' : '';

const fetchTeamStories = (args) => doDefaultFetch(
    `/site/api/team-stories${publicUrl(args)}/options?cayenneExp=storySlug="${args.name}"`,
    args
);

const fetchTeamStoryDetails = (args) => doDefaultFetch(
    `/site/api/team-stories${publicUrl(args)}/details/${args.id}`,
    args
);

export default {
    fetchTeamStories,
    fetchTeamStoryDetails,
};
